import { format } from 'date-fns'

export type DateProps = {
  value?: Date | string | number
}

function parse(date) {
  if (typeof date === 'string') {
    return new Date(date)
  }

  if (typeof date === 'number') {
    return new Date(date)
  }

  if (typeof date === 'object') {
    return date
  }
}

export function DateDisplay({ value }: DateProps) {
  if (value === undefined || value === '') {
    return <>-</>
  }

  const rawValue = parse(value)

  return <>{format(rawValue, 'dd MMMM yyyy')}</>
}

export function DateAndTime({ value }: DateProps) {
  if (value === undefined) {
    return <>-</>
  }

  const rawValue = parse(value)

  return <>{format(rawValue, 'dd MMMM yyyy HH:mm')}</>
}
